/** Icon badge severity, aligned with PrimeNG naming. */
export type MetricCardIconSeverity = 'info' | 'primary';

export interface MetricCardIconSeverityStyle {
  container: string;
  color: string;
}

/** Visual styles for the metric-card icon badge per severity. */
export const METRIC_CARD_ICON_SEVERITY_STYLES: Record<MetricCardIconSeverity, MetricCardIconSeverityStyle> = {
  info: {
    container: 'bg-blue-100 dark:bg-blue-400/10',
    color: 'text-blue-400/80 dark:text-blue-100',
  },
  primary: {
    container: 'bg-surface-100 dark:bg-surface-800',
    color: 'text-surface-700 dark:text-surface-200',
  },
};

/** Default icon badge severity. */
export const METRIC_CARD_ICON_DEFAULT_SEVERITY: MetricCardIconSeverity = 'info';
